import {Utils} from '../../common/scripts/utils';

const flatsPromotion = document.querySelector('.j-flats-promotion');
const mobileClass = 'flats-promotion__section_theme_mobile';


if (flatsPromotion) {
    /**
     * Проверяем тач устройство или нет
     */
    const checkMobileClass = () => {
        Utils.isMobile() && Utils.isTouchDevice() ?
            flatsPromotion.classList.add(mobileClass) :
            flatsPromotion.classList.remove(mobileClass);
    };

    checkMobileClass();

    const events = ['resize', 'orientationchange'];

    events.forEach((event) => {
        window.addEventListener(event, checkMobileClass);
    });
}

